module.exports = __webpack_public_path__ + "img/certTJ1.ac5e7b30.jpg";